import Vue from 'vue';
import axios from "axios";
// import _ from "lodash"
import cartHandler from "@/services/cartHandler";


import findIndex from 'lodash/findIndex';
import findLodash from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';
import filter from 'lodash/filter';

import CryptoJS from 'crypto-js';
import { triggerHaptic } from "@/utils/haptics"
import {getProxyAccessToken} from "../../plugins/cookie-plugins"
import {proxyPath, proxyBody, proxyHeaders} from "../../utils/b2bProxy"
import {isFrozen as isOutcomeFrozen} from "@/services/frozenOddsRegistry.service"
import {notifyBetPlaced} from "@/services/parentBridge/betPlacedEvent"



const RESOLVED_REVIEW_CODES_MAX = 100;

function markReviewResolved(state, codes) {
    const fresh = codes.filter(c => c != null).map(String)
        .filter(c => !state.resolved_review_codes.includes(c));
    if (!fresh.length) return;
    state.resolved_review_codes = [...state.resolved_review_codes, ...fresh].slice(-RESOLVED_REVIEW_CODES_MAX);
}

// Le API di review possono rispondere 2xx con { result: false, error_code, reason }
// oppure 4xx con { code, description }: normalizza tutto in { data: { result, error_code, reason } }.
function normalizeReviewResponse(res) {
    const body = (res && res.data) || {};
    const errorCode = body.error_code || body.code || null;
    const result = body.result !== false && !(body.result == null && errorCode);
    return { status: res && res.status, data: { ...body, result, error_code: result ? null : errorCode, reason: body.reason || body.description || null } };
}

function normalizeReviewError(error) {
    const body = (error && error.response && error.response.data) || {};
    return {
        status: error && error.response ? error.response.status : null,
        data: { ...body, result: false, error_code: body.error_code || body.code || null, reason: body.reason || body.description || null },
    };
}

// Payload comune a place-bet e compatible-free-bets: il backend valuta la
// compatibilità delle freebet sullo stesso carrello che verrebbe giocato.
// omitAmount: compatible-free-bets non deve ricevere l'importo, la compatibilità
// dipende solo da tipo e selezioni (l'importo lo fissa poi la freebet).
function buildBetRequestPayload(context, { betContext, lang, accept_odds, omitAmount = false }) {
    const betToVerify = {
        odds_sources: context.state.odds_sources,
        bet: {
            odds: context.state.bet.odds,
            type: context.state.bet.type
        }
    }

    let amountBet = 0.00;

    switch (context.state.bet.type) {
        case "single":
        case "multiple":
            if (omitAmount) {
                // eslint-disable-next-line no-unused-vars
                const { amount, ...multipleDetail } = context.state.bet._multiple_detail;
                betToVerify.bet._multiple_detail = multipleDetail
            } else {
                betToVerify.bet._multiple_detail = context.state.bet._multiple_detail
            }
            amountBet = +context.state.bet._multiple_detail.amount;
            break
        case "integral":
            betToVerify.bet._integral_detail = context.state.bet._integral_detail
            amountBet = +context.state.bet._integral_detail.amount_total;
            break
        case "system":
            betToVerify.bet._system_detail = context.state.bet._system_detail
            betToVerify.bet.system_parts = context.state.bet.system_parts
            amountBet = +context.state.bet._system_detail.amount_system;
            break
    }

    const encryptedText = CryptoJS.AES.encrypt(JSON.stringify(context.state.odds_sources), process.env.VUE_APP_HASH_FORM).toString();

    const userInfo = {
        id: context.rootGetters['user/getId'],
        login: context.rootGetters['user/getLogin'],
        agencyId: context.rootGetters['user/getAgencyNet'],
        agencyLogin: context.rootGetters['user/getAgencyLogin'],
        operatorId: context.rootGetters['user/getOperatorNet'],
        operatorLogin: context.rootGetters['user/getOperatorLogin']
    }

    const payload_request = {
        "betContext": betContext,
        "bet_to_check": JSON.stringify(betToVerify),
        "lang": lang,
        "accept_odds": accept_odds,
        "hash": encryptedText,
        "type_user": (context.rootGetters['user/getType'] == 4 || context.rootGetters['user/getCashier']) ? 'retail' : 'user',
        "userInfo": userInfo,
        "eventViewMode": context.rootGetters['ui/getEventViewMode']
    }

    // B2B flows carry the operator token as `gaimToken` on the
    // place-bet request so the backend can bind the wager to the
    // remote gaming session. Only attached when B2B is on AND we
    // actually have a token — never send an empty/undefined field.
    if (context.rootGetters['settings/getB2bEnabled']) {
        const gaimToken = context.rootGetters['user/getB2bToken'];
        if (gaimToken) payload_request.gaimToken = gaimToken;
    }

    return { payload_request, amountBet };
}

// Le freebet sostituiscono l'importo della giocata: supportate solo dove
// l'importo inserito coincide con la puntata (singola/multipla).
const FREE_BET_TYPES = ['single', 'multiple'];
const FREE_BETS_DEBOUNCE_MS = 400;
let freeBetsDebounceTimer = null;

// L'importo non fa parte del payload di compatible-free-bets: cambiarlo non
// richiede una nuova chiamata (deseleziona solo la freebet scelta).
function freeBetsKey(state) {
    return [state.bet.type, state.odds_sources.join('|')].join('#');
}

// Message of a failed automatic recharge: payments answers a 422 with {message} or {error}
function autoRechargeErrorMessage(error) {
    const data = error && error.response && error.response.data;
    if (data && typeof data.message === 'string') {
        return data.message;
    }
    if (data && data.error) {
        return typeof data.error === 'string' ? data.error : data.error.message || null;
    }
    return null;
}

const state = {
    loading: false,
    odds_sources: [],
    bonus_rules: [],
    settings: {},
    odds_variation: true,
    bet: {
        _multiple_detail: {
            amount: 0.00,
            bonus: 0.00,
            bonus_percentage: 0,
            multiplicity: 0,
            odds_total: 0.00,
            profit: 0.00,
            winning: 0.00,
            winning_total: 0.00,
        },
        _integral_detail: {
            amount: 0.00,
            amount_total: 0.00,
            bonus_percentage: 0,
            bonus_max: 0.00,
            bonus_min: 0.00,
            combinations: 0,
            multiplicity: 0,
            odds_total_max: 0.00,
            odds_total_min: 0.00,
            profit_max: 0.00,
            profit_min: 0.00,
            winning_max: 0.00,
            winning_min: 0.00,
            winning_total_max: 0.00,
            winning_total_min: 0.00,
        },
        _system_detail: {
            amount_system: 0.00,
            amount_system_equal: null,
            amount_system_to_divide: null,
            bonus_max: 0.00,
            bonus_min: 0.00,
            combinations: 0,
            fixed_bases: [],
            // multiplicity: 0,
            // odds_total_max : 0.00,
            // odds_total_min : 0.00,
            // profit_max: 0.00,
            // profit_min: 0.00,
            valid_combinations_all: 0,
            winning_max: 0.00,
            winning_min: 0.00,
            winning_total_max: 0.00,
            winning_total_min: 0.00,
            winning_all: 0.00
        },

        check: true,
        errors: [],
        warnings: [],
        integral_parts: [],
        odds: [],
        system_parts: [],
        type: 'single',
        context: '',
        errors_multi_info: []
    },
    created_at: 0,
    accepting_bets: [],
    accepted_bets: [],
    accepted_with_change: [],
    // Codici delle riproposte già accettate/rifiutate: un re-invio socket
    // (es. al reload/riconnessione) non deve riproporle.
    resolved_review_codes: [],
    rejected_bets: [],
    mobileCartOpen: false,
    combinableMarkets: [],
    isCartUpdating: false,
    confirmed_bet: null,
    // Freebet: null = non ancora caricate (available-free-bets)
    available_free_bets: null,
    compatible_free_bets: [],
    selected_free_bet_id: null,
    free_bet_previous_amount: null,
    free_bets_loading: false,
    free_bets_last_key: null,
    free_bets_request_seq: 0,
    // The embedding page has just set the stake (parent bridge SPORT_SLIP_SET_STAKE): place bet
    // waits a moment, so the player sees the new amount before the click. Not persisted.
    parent_stake_lock: false
};

// A bet builder is played only in a single or a multiple: rocky-bets refuses it in a
// system or an integral (BET_BUILDER_BET_TYPE_NOT_ALLOWED), whose combinations would take
// its legs one by one.
const cartHasBetBuilder = (bet) => Boolean(bet) && (bet.odds || []).some(o => o && o.is_bet_builder === true);

const getters = {
    getLoading: state => {
        return state.loading;
    },
    getOddsSources: state => {
        return state.odds_sources;
    },
    getBet: state => {
        return state.bet;
    },
    hasBetBuilder: state => cartHasBetBuilder(state.bet),
    getBetSystemParts: state => {
        return state.bet.system_parts;
    },
    getSettings: state => {
        return state.settings
    },
    getParentStakeLock: state => state.parent_stake_lock === true,
    getBonusRules: state => {
        return state.bonus_rules
    },
    getOddsVariation: state => {
        return state.odds_variation;
    },
    getBetOdds: state => {
        return state.bet.odds;
    },
    getAcceptingBets: state => {
        return state.accepting_bets;
    },
    getAcceptedBets: state => {
        return state.accepted_bets;
    },
    getAcceptedBetWithChange: state => {
        return state.accepted_with_change;
    },
    getRejectedBets: state => {
        return state.rejected_bets;
    },
    getMobileCartOpen: state => {
        return state.mobileCartOpen
    },
    getCombinableMarkets: state => {
        return state.combinableMarkets
    },
    getIsCartUpdating: state => {
        return state.isCartUpdating
    },
    getConfirmedBet: state => {
        return state.confirmed_bet
    },
    getAvailableFreeBets: state => {
        return state.available_free_bets
    },
    getCompatibleFreeBets: state => {
        return state.compatible_free_bets
    },
    getSelectedFreeBet: state => {
        if (!state.selected_free_bet_id) return null;
        return state.compatible_free_bets.find(t => t.tokenId === state.selected_free_bet_id) || null
    },
    getFreeBetsLoading: state => {
        return state.free_bets_loading
    }
};

const actions = {
    async replaceOdds(context, payload) {
        if (payload.odds.length > 0) {

            var newBetOdds = context.state.bet.odds

            for (let odd of payload.odds) {

                switch (odd.reason) {
                    case 'changed_odd_value':
                    case 'changed_multiplicity':
                        var index = findIndex(newBetOdds, function (odd_to_find) {
                            return odd_to_find.unique_id == odd.source
                        });
                        if (index >= 0) {
                            newBetOdds[index] = odd.newOdd
                        }
                        break
                    case 'disabled':
                    case 'time_over':
                        var odd_to_find = findLodash(newBetOdds, {'unique_id': odd.source})
                        odd_to_find.to_remove = true
                        // console.log(odd_to_find.to_remove)
                        // return
                        // remove(newBetOdds, function(odd_to_find) {
                        //     return odd_to_find.unique_id == odd.source;
                        // });
                        break
                }

            }

            context.commit('SET_ODDS', newBetOdds)

        }
    },
    async placeBet(context, payload) {
        return new Promise(async (resolve, reject) => {

            if (context.state.odds_sources.length > 0) {

                const { payload_request, amountBet } = buildBetRequestPayload(context, payload);

                // Freebet selezionata: valida solo se ancora compatibile e con
                // l'importo invariato (cambiare importo deseleziona la freebet).
                const selectedFreeBet = context.getters.getSelectedFreeBet;
                if (selectedFreeBet && FREE_BET_TYPES.includes(context.state.bet.type)
                    && Number(selectedFreeBet.amount) === Number(context.state.bet._multiple_detail.amount)) {
                    payload_request.freeBetId = selectedFreeBet.tokenId;
                }

                const userIdOfUserToPlayBetFor = context.rootGetters['user/getUserIdOfUserToPlayBetFor'];
                const loginOfUserToPlayBetFor = context.rootGetters['user/getLoginOfUserToPlayBetFor'];

                if (userIdOfUserToPlayBetFor != null && loginOfUserToPlayBetFor != null) {
                    payload_request.playerId = +userIdOfUserToPlayBetFor;
                    payload_request.playerLogin = loginOfUserToPlayBetFor.toString()

                    // The switch of the agency, honoured only when the skin enables the feature and an
                    // agency is placing: a switch left on in the store must not top up on a skin that does
                    // not offer it, nor for a cashier playing on behalf (no automatic recharge for cashiers)
                    const automaticRecharge = context.rootGetters['settings/getEnableAgencyAutoRecharge'] === true
                        && context.rootGetters['settings/getEnableAutoRecharge'] === true
                        && context.rootGetters['user/getType'] === 4
                        && context.rootGetters['user/getCashier'] !== true;

                    if (automaticRecharge === true) {
                        // A failed balance read or top up stops the placement with an answer the cart
                        // shows. Thrown here, inside the Promise executor, it would leave placeBet
                        // pending forever (cart stuck on loading).
                        try {
                            const checkBalance = await context.dispatch('user/getUserSportBalance', {
                                customerId: context.rootGetters['settings/getCustomerId'],
                                userId: +userIdOfUserToPlayBetFor
                            }, {root: true})

                            if ((+checkBalance) < (+amountBet)) {
                                const valueToRecharge = (+amountBet) - (+checkBalance);

                                // depositTransfer builds customer, reference, login and passCode itself
                                const responseRecharge = await context.dispatch('user/depositTransfer', {
                                    amount: valueToRecharge.toString(),
                                    receiverIdUser: payload_request.playerId.toString(),
                                    receiverLogin: payload_request.playerLogin
                                }, {root: true});

                                if (!responseRecharge || !responseRecharge.data || responseRecharge.data.status !== true) {
                                    throw new Error('Automatic recharge not confirmed by payments');
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            resolve({result: false, error_code: 'AUTO_RECHARGE_FAILED', reason: autoRechargeErrorMessage(error)});
                            return;
                        }
                    }
                }

                // let url = `${context.rootGetters['settings/getBetApiUrl']}/cart/v2/place-bet`;
                //
                // await axios.post(`${url}`, payload_request, {'headers': {'Authorization': `Bearer ${context.rootGetters['user/getToken']}`}})
                let url = `${context.rootGetters['settings/getProxyUrl']}${proxyPath(context.rootGetters, '/cart/v3/place-bet')}`;

                await axios.post(`${url}`, proxyBody(context.rootGetters, payload_request), {headers: proxyHeaders(context.rootGetters, getProxyAccessToken())})
                    .then((res) => {
                        // Il token è stato consumato: ricarica le freebet dell'utente.
                        if (payload_request.freeBetId && res.data && res.data.result === true) {
                            context.dispatch('reloadFreeBets');
                        }
                        resolve(res.data)
                        // Parent bridge: outcome of the placement for the embedding page. After resolve
                        // and never throwing (runSafely): the answer the cart gets cannot depend on it.
                        notifyBetPlaced(res.data, context.state.bet);
                    }).catch((error) => {
                        // Usa resolve (non reject) così il componente riceve sempre i dati
                        // dell'errore e può mostrare un messaggio appropriato all'utente.
                        const errorData = (error.response && error.response.data)
                            ? error.response.data
                            : { result: false };
                        resolve(errorData);
                        notifyBetPlaced(errorData, context.state.bet);
                        console.log(error);
                    });

            } else {
                resolve({error_code: 'event_not_avaiable'})
            }


        })

    },
    async placeBetChanged(context, payload) {
        // console.log('placeBetChanged');
    },
    async bookBet(context, payload) {
        return new Promise(async (resolve, reject) => {

            if (context.state.odds_sources.length > 0) {

                var betToVerify = {
                    odds_sources: context.state.odds_sources,
                    bet: {
                        odds: context.state.bet.odds,
                        type: context.state.bet.type
                    }
                }
                switch (context.state.bet.type) {
                    case "single":
                    case "multiple":
                        betToVerify.bet._multiple_detail = context.state.bet._multiple_detail
                        break
                    case "integral":
                        betToVerify.bet._integral_detail = context.state.bet._integral_detail
                        break
                    case "system":
                        betToVerify.bet._system_detail = context.state.bet._system_detail
                        betToVerify.bet.system_parts = context.state.bet.system_parts
                        break
                }

                var payload_request = {
                    "betContext": payload.betContext,
                    "bet_to_check": JSON.stringify(betToVerify),
                    "lang": payload.lang,
                    "eventViewMode": context.rootGetters['ui/getEventViewMode']
                }

                let url = `${context.rootGetters['settings/getBetApiUrl']}/cart/v2/book-bet`;

                await axios.post(`${url}`, payload_request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
                    .then((res) => {
                        resolve(res.data)
                    }).catch((error) => {
                        const errorData = (error.response && error.response.data)
                            ? error.response.data
                            : { result: false };
                        resolve(errorData);
                        console.log(error);
                    });

            } else {
                resolve({ result: false, error_code: 'event_not_avaiable' })
            }


        })

    },
    async oddChangeFromSocketCart(context, payload) {

        if (context.state.odds_sources.length > 0 && !isEmpty(payload)) {
            var source_to_find = payload._attributes.event_id;
            var odds_to_refresh = [];

            for (let oddSource of context.state.odds_sources) {
                if (oddSource.includes(source_to_find)) {
                    odds_to_refresh.push(oddSource)
                }
            }

            if (!isEmpty(odds_to_refresh)) {

                await Promise.all(Object.keys(odds_to_refresh).map(async (index) => {

                        var odd_source = odds_to_refresh[index];
                        var split = odd_source.split(';')
                        var spec = ''

                        var market = split[1]
                        var outcome = split[2]

                        if (split[1].includes('#')) {
                            let spec_split = split[1].split('#')
                            market = spec_split[0]
                            spec = spec_split[1]
                        }
                        var newOdds = findLodash(payload.odds.market, function (mark) {
                            if (spec != '') {
                                return (mark._attributes.id == market && mark._attributes.specifiers == spec)
                            } else {
                                return mark._attributes.id == market
                            }
                        })

                        if (newOdds != undefined) {


                            var newOutcome = findLodash(newOdds.outcome, function (out) {
                                return out._attributes.id == outcome
                            });

                            var oldOutcome = findLodash(context.state.bet.odds, function (oldOut) {
                                return oldOut.unique_id == odd_source
                            });

                            if (newOutcome != undefined && oldOutcome != undefined) {

                                // ToDo Update Cart from Server
                                this.$root.$emit('forceUpdateOddsSummary')
                                this.$root.$emit('forceUpdateSystem')
                                this.$root.$emit('forceUpdateSingleMultiple')
                                this.$root.$emit('forceUpdateIntegral')

                            }
                        }
                    })
                )
            }
        }
    },
    async addOddToCart(context, payload) {
        var limit = 20
        var oddObj = JSON.parse(JSON.stringify(payload.odd))
        var eventObj = payload.event
        var sportObj = payload.sport
        var categoryObj = payload.category
        var tournamentObj = payload.tournament

        if (context.state.bet.odds.length == 0) {
            context.state.created_at = new Date().getTime()
            const s = context.state.settings;
            const initMin = oddObj.type === 'live' && +s.live_min_amount > 0 ? +s.live_min_amount : s.minAmount;
            if (context.state.bet.type == "single" || context.state.bet.type == "multiple") {
                context.state.bet._multiple_detail.amount = initMin
            } else if (context.state.bet.type == "integral") {
                context.state.bet._integral_detail.amount = initMin
            }
        }

        if (!context.state.odds_sources.includes(oddObj.unique_id)) {

            if (context.state.bet.odds.length >= limit && context.state.bet.type == "system") {
                context.dispatch('settings/setSnackbar', true, {root: true})
                context.dispatch('settings/setSnackbarText', 'maximumOddsSystem', {root: true})
                return
            }

            context.commit('ADD_ODD_SOURCE', oddObj.unique_id)
            const odd = await cartHandler.refactorOdd(oddObj, eventObj, sportObj, categoryObj, tournamentObj)

            if (context.state.settings.integral) {

                context.commit('ADD_ODD', odd)

            } else {

                var checkDoubleOdds = await findLodash(context.state.bet.odds, {'event_source': oddObj.event_source});

                if (checkDoubleOdds != undefined && !isEmpty(checkDoubleOdds)) {

                    await context.dispatch('removeOddFromCart', checkDoubleOdds)

                }

                context.commit('ADD_ODD', odd)

            }

        } else {

            await context.dispatch('removeOddFromCart', oddObj)
            await context.dispatch('checkFixedBaseSystem', oddObj)
        }

        await context.dispatch("refreshCart")
    },
    async addOddToCartV3(context, payload) {


        // Se c'è una scommessa confermata e getEnableClearCartAtPlaceBet è attivo,
        // resettiamo completamente il carrello prima di aggiungere la nuova quota.
        if (context.state.confirmed_bet && context.rootState.settings.enableClearCartAtPlaceBet) {
            context.commit('CLEAR_CONFIRMED_BET');
            context.commit('RESET_CART');
        } else if (context.state.confirmed_bet) {
            context.commit('CLEAR_CONFIRMED_BET');
        }

        var limit = 20
        var marketObj = payload.oddMarket != null ? JSON.parse(JSON.stringify(payload.oddMarket)) : null
        var oddObj = JSON.parse(JSON.stringify(payload.odd))
        if (payload.type) oddObj.type = payload.type

        var eventObj = payload.event
        var sportObj = payload.sport
        var categoryObj = payload.category
        var tournamentObj = payload.tournament


        if (context.state.bet.odds.length == 0) {
            context.state.created_at = new Date().getTime()
            const s = context.state.settings;
            const initMin = oddObj.type === 'live' && +s.live_min_amount > 0 ? +s.live_min_amount : s.minAmount;
            if (context.state.bet.type == "single" || context.state.bet.type == "multiple") {
                context.state.bet._multiple_detail.amount = initMin
            } else if (context.state.bet.type == "integral") {
                context.state.bet._integral_detail.amount = initMin
            }
        }

        if (!context.state.odds_sources.includes(oddObj.unique_id)) {

            if (context.state.bet.odds.length >= limit && context.state.bet.type == "system") {
                context.dispatch('settings/setSnackbar', true, {root: true})
                context.dispatch('settings/setSnackbarText', 'maximumOddsSystem', {root: true})
                return
            }

            context.commit('ADD_ODD_SOURCE', oddObj.unique_id)
            const odd = await cartHandler.refactorOddV3(marketObj,oddObj, eventObj, sportObj, categoryObj, tournamentObj)
            odd.provider = "lsport"
            if (odd.is_bet_builder == null) odd.is_bet_builder = false



            const enableBetBuilder = context.rootGetters['settings/getEnableBetBuilder'];

            if (!oddObj.bet_builder_id && enableBetBuilder) {
                const existingFromSameEvent = context.state.bet.odds.filter(
                    o => o.event_source === odd.event_source
                );
                const isLive = odd.type === 'live' || oddObj.type === 'live';
                const isAntepost = odd.type === 'antepost' || oddObj.type === 'antepost';
                // Live bet builder (skin enableLiveBetBuilder, DataSavage): a live event forms a
                // bet builder too, unless the live detail already knows it is not offered.
                // rocky-bets has the last word (sport, match state) on the quote.
                const liveBetBuilder = isLive
                    && context.rootGetters['settings/getEnableLiveBetBuilder']
                    && context.rootGetters['betbuilder/isLiveEventAvailable'](odd.event_source) !== false;

                if (existingFromSameEvent.length > 0 && !isAntepost && (!isLive || liveBetBuilder)) {
                    // Same event already in the cart (prematch, or live with the live bet builder): try a bet builder
                    context.commit('ADD_ODD', odd)
                    triggerHaptic("light")

                    context.commit('SET_LOADING_CART', true)
                    const bbResult = await context.dispatch('calculateBetBuilder', {
                        odds: [...existingFromSameEvent, odd],
                    })
                    context.commit('SET_LOADING_CART', false)

                    if (bbResult.success) {
                        context.commit('SET_BET_BUILDER_GROUP', {
                            eventSource: odd.event_source,
                            correlationId: bbResult.data.correlationId,
                            combinedPrice: bbResult.data.price,
                        })
                    } else if (bbResult.errorCode === 'BET_BUILDER_UNAVAILABLE') {
                        // Provider overloaded or unreachable (temporary): keep the group, the player retries.
                        context.commit('SET_BET_BUILDER_UNAVAILABLE', { eventSource: odd.event_source })
                    } else if (bbResult.errorCode === 'selections_redundant') {
                        context.commit('SET_BET_BUILDER_REDUNDANT', {
                            eventSource: odd.event_source,
                            syntheticId: bbResult.quoteId || ('redundant__' + odd.event_source),
                            redundantOutcomeId: bbResult.redundantOutcomeId,
                            impliedByOutcomeId: bbResult.impliedByOutcomeId,
                        })
                    } else if (isLive) {
                        // Live not priceable as a bet builder (sport, match state, combination):
                        // say why, then the classic live behaviour, the new selection replaces those
                        // of the same event. A skin with integrals keeps them all: the cart check
                        // (sameEventVincols) then blocks the bet until one is removed.
                        context.dispatch('settings/setSnackbar', true, {root: true})
                        context.dispatch('settings/setSnackbarText', bbResult.errorCode === 'selections_impossible'
                            ? 'errors.betBuilderImpossibleLive'
                            : 'errors.betBuilderNotCombinable', {root: true})
                        if (!context.state.settings.integral) {
                            for (const existing of existingFromSameEvent) {
                                await context.dispatch('removeOddFromCart', {...existing, skipBetBuilderRecalc: true})
                            }
                        }
                    } else {
                        // Combinazione non disponibile per betbuilder → passa a integrale
                        context.commit('DISSOLVE_BET_BUILDER_GROUPS')
                        context.commit('SET_BET_TYPE', 'integral')
                    }
                } else if (existingFromSameEvent.length > 0 && isLive) {
                    // Evento live: niente betbuilder, sostituisce la quota esistente dello stesso evento
                    if (!context.state.settings.integral) {
                        for (const existing of existingFromSameEvent) {
                            await context.dispatch('removeOddFromCart', existing)
                        }
                    }
                    context.commit('ADD_ODD', odd)
                    triggerHaptic("light")
                } else {
                    // Evento diverso: aggiunta normale
                    context.commit('ADD_ODD', odd)
                    triggerHaptic("light")
                }
            } else {
                // Bet builder disabilitato oppure quota precompilata betbuilder:
                // comportamento classico — se stesso evento già presente, rimuove e sostituisce
                if (!oddObj.bet_builder_id) {
                    const existingFromSameEvent = context.state.bet.odds.filter(
                        o => o.event_source === odd.event_source
                    );
                    if (existingFromSameEvent.length > 0 && !context.state.settings.integral) {
                        for (const existing of existingFromSameEvent) {
                            await context.dispatch('removeOddFromCart', existing)
                        }
                    }
                }
                context.commit('ADD_ODD', odd)
                triggerHaptic("light")
            }




        } else {

            await context.dispatch('removeOddFromCart', oddObj)
            await context.dispatch('checkFixedBaseSystem', oddObj)
            triggerHaptic("medium")
        }

        await context.dispatch("refreshCart")
    },
    // Bet builder group left waiting by a temporary provider failure (BET_BUILDER_UNAVAILABLE):
    // the player's retry quotes it again, with the same outcomes as when the group is formed.
    async retryBetBuilderGroup(context, { eventSource }) {
        const group = context.state.bet.odds.filter(o => o.event_source === eventSource);
        if (group.length < 2) return;
        context.commit('SET_LOADING_CART', true);
        const bbResult = await context.dispatch('calculateBetBuilder', { odds: group });
        context.commit('SET_LOADING_CART', false);
        if (bbResult.success) {
            context.commit('SET_BET_BUILDER_GROUP', { eventSource, correlationId: bbResult.data.correlationId, combinedPrice: bbResult.data.price });
        } else if (bbResult.errorCode === 'BET_BUILDER_UNAVAILABLE') {
            context.commit('SET_BET_BUILDER_UNAVAILABLE', { eventSource });
        } else if (bbResult.errorCode === 'selections_redundant') {
            context.commit('SET_BET_BUILDER_REDUNDANT', {
                eventSource,
                syntheticId: bbResult.quoteId || ('redundant__' + eventSource),
                redundantOutcomeId: bbResult.redundantOutcomeId,
                impliedByOutcomeId: bbResult.impliedByOutcomeId,
            });
        } else {
            // The combination cannot be priced: as when the group is formed, an integral.
            context.commit('DISSOLVE_BET_BUILDER_GROUPS');
            context.commit('SET_BET_TYPE', 'integral');
        }
        await context.dispatch('refreshCart');
    },
    async calculateBetBuilder(context, { odds }) {
        const proxyUrl = context.rootGetters['settings/getProxyUrl'];
        const selections = odds.map(o => ({
            provider: o.provider || 'lsport',
            outcomeId: String(o.unique_id),
        }));
        // Through the skin proxy (it adds the player passport).
        const url = `${proxyUrl}/bets/cart/self/betbuilder/calculate?raw=true`;
        try {
            const res = await axios.post(
                url,
                selections,
                { headers: {  } }
            );
            return {
                success: true,
                data: {
                    correlationId: res.data.correlationId,
                    price: res.data.final_odd,
                    raw: res.data,
                },
            };
        } catch (err) {
            const errorData = err.response && err.response.data;
            return {
                success: false,
                // No answer, or a 5xx without our error body (proxy, gateway): temporary, like
                // rocky-bets' own BET_BUILDER_UNAVAILABLE (provider overloaded or down).
                errorCode: (errorData && errorData.code)
                    || (!err.response || err.response.status >= 500 ? 'BET_BUILDER_UNAVAILABLE' : undefined),
                quoteId: errorData && errorData.extraData && errorData.extraData.quote_id,
                // selections_redundant: the selection to remove and the one that already covers it.
                redundantOutcomeId: errorData && errorData.extraData && errorData.extraData.redundant ? String(errorData.extraData.redundant.outcomeId) : null,
                impliedByOutcomeId: errorData && errorData.extraData && errorData.extraData.impliedBy ? String(errorData.extraData.impliedBy.outcomeId) : null,
                reason: errorData && errorData.description,
            };

        }
    },
    // DISABLED on purpose (2026-10-12): do not re-enable.
    // Old direct Datasavage quote, written before the bet builder was priced by rocky-bets. It
    // builds the Datasavage request in the player's browser, marginal odds included, and posts it
    // to `<skin proxy>/bb/datasavage/v1/quote`. Nothing calls it: the cart prices bet builders with
    // `calculateBetBuilder` (rocky-bets POST /cart/self/betbuilder/calculate), which refuses
    // suspended or closed odds and closed events, applies the live checks and takes the marginal
    // odds from the feed.
    // Kept, commented, as a reminder: if the skin proxy still exposes /bb/datasavage/*, anyone can
    // call Datasavage on our account with made-up marginal odds and none of our checks. That route
    // must be checked and removed on the proxy (not in this repository). The price could never be
    // paid (rocky-bets re-prices every placed bet), but the provider account would be open to anyone.
    // See rocky-bets docs/placebet-prematch-live-betbuilder.md, section 7.
    // async calculateBetBuilderDataSavage(context, { odds }) {
    //     const matchId = odds[0] && odds[0].event_source;
    //     const selections = odds.map(o => {
    //         const isPlayer = (o.partecipantId != null) || (o.participantId != null);
    //         const sel = {
    //             market: o.id_market != null ? String(o.id_market) : (o.market_name || ''),
    //             outcome: isPlayer ? 'yes' : (o.outcome_name != null ? String(o.outcome_name) : ''),
    //         };
    //         if (isPlayer) sel.player_id = o.playerId != null ? String(o.playerId) : '';
    //         const line = o.Line != null ? o.Line : (o.line != null ? o.line : null);
    //         if (line != null && line !== '') sel.line = parseFloat(line);
    //         return sel;
    //     });
    //     const marginalOdds = odds.map(o => parseFloat(o.bb_original_odd_value ?? o.outcome_odd_value) || 1);
    //
    //     let bd = {
    //         match: { id: String(matchId) },
    //         selections,
    //         marginal_odds: marginalOdds,
    //     }
    //
    //
    //     try {
    //         const proxyUrl = context.rootGetters['settings/getProxyUrl'];
    //         const res = await axios.post(
    //             `${proxyUrl}/bb/datasavage/v1/quote`,
    //             {
    //                 match: { id: String(matchId) },
    //                 selections,
    //                 marginal_odds: marginalOdds,
    //             },
    //             { headers: { 'Content-Type': 'application/json' } }
    //         );
    //         // Mappa risposta API: quote_id → correlationId, final_odd → price
    //         return {
    //             success: true,
    //             data: {
    //                 correlationId: res.data.quote_id,
    //                 price: res.data.final_odd,
    //                 raw: res.data,
    //             },
    //         };
    //     } catch (err) {
    //         const errorData = err.response && err.response.data;
    //         return {
    //             success: false,
    //             errorCode: errorData && errorData.error && errorData.error.code,
    //             quoteId: errorData && errorData.error && errorData.error.quote_id,
    //             reason: errorData && errorData.reason,
    //         };
    //     }
    // },
    async _cleanBetBuilderGroups(context) {
        const groups = {};
        for (const odd of context.state.bet.odds) {
            if (odd.bet_builder_id) {
                if (!groups[odd.bet_builder_id]) groups[odd.bet_builder_id] = [];
                groups[odd.bet_builder_id].push(odd);
            }
        }
        let needsUpdate = false;
        const updatedOdds = context.state.bet.odds.map(o => ({ ...o }));
        for (const [bbId, groupOdds] of Object.entries(groups)) {
            if (groupOdds.length < 2) {
                for (const odd of updatedOdds) {
                    if (odd.bet_builder_id === bbId) {
                        odd.bet_builder_id = null;
                        odd.is_bet_builder = false;
                        odd.bb_redundant = false;
                        odd.bb_redundant_leg = false;
                        odd.bb_implied_by = null;
                        odd.bb_unavailable = false;
                        if (odd.bb_original_odd_value != null) {
                            odd.outcome_odd_value = odd.bb_original_odd_value;
                            delete odd.bb_original_odd_value;
                        }
                        needsUpdate = true;
                    }
                }
            }
        }
        if (needsUpdate) {
            context.commit('SET_ODDS', updatedOdds);
        }
    },
    async removeOddFromCart(context, payload) {

        var odds = remove(context.state.bet.odds, function (odd) {
            return odd.unique_id != payload.unique_id;
        });

        await context.commit('SET_ODDS', odds)

        var active = remove(context.state.odds_sources, function (odd) {
            return odd != payload.unique_id;
        });

        await context.commit('SET_ODDS_SOURCE', active)
        await context.dispatch('_cleanBetBuilderGroups')

        // Ricalcola betbuilder per i gruppi ancora attivi (≥2 quote rimaste)
        // Saltato se il chiamante sta rimuovendo l'intero gruppo betbuilder
        if (payload.skipBetBuilderRecalc) return;
        const enableBetBuilder = context.rootGetters['settings/getEnableBetBuilder'];
        if (enableBetBuilder) {
            const groups = {};
            for (const odd of context.state.bet.odds) {
                if (odd.bet_builder_id) {
                    if (!groups[odd.bet_builder_id]) groups[odd.bet_builder_id] = [];
                    groups[odd.bet_builder_id].push(odd);
                }
            }
            const activeGroups = Object.values(groups).filter(g => g.length >= 2);
            if (activeGroups.length > 0) {
                context.commit('SET_LOADING_CART', true);
                const activeResults = await Promise.all(
                    activeGroups.map(group =>
                        context.dispatch('calculateBetBuilder', { odds: group }).then(r => ({ group, r }))
                    )
                );
                let dissolved = false;
                for (const { group, r: bbResult } of activeResults) {
                    if (bbResult.success) {
                        context.commit('SET_BET_BUILDER_GROUP', {
                            eventSource: group[0].event_source,
                            correlationId: bbResult.data.correlationId,
                            combinedPrice: bbResult.data.price,
                        });
                    } else if (bbResult.errorCode === 'BET_BUILDER_UNAVAILABLE') {
                        // Provider overloaded or unreachable (temporary): keep the group, the player retries.
                        context.commit('SET_BET_BUILDER_UNAVAILABLE', { eventSource: group[0].event_source })
                    } else if (bbResult.errorCode === 'selections_redundant') {
                        context.commit('SET_BET_BUILDER_REDUNDANT', {
                            eventSource: group[0].event_source,
                            syntheticId: bbResult.quoteId || ('redundant__' + group[0].event_source),
                            redundantOutcomeId: bbResult.redundantOutcomeId,
                            impliedByOutcomeId: bbResult.impliedByOutcomeId,
                        });
                    } else if (!dissolved) {
                        dissolved = true;
                        context.commit('DISSOLVE_BET_BUILDER_GROUPS');
                        context.commit('SET_BET_TYPE', 'integral');
                    }
                }
                context.commit('SET_LOADING_CART', false);
            }

            // Recovery: se il tipo è ancora 'integral' dopo la rimozione, prova a ricomporre
            // il betbuilder dai gruppi di quote prematch dello stesso evento (bet_builder_id=null
            // perché in precedenza DISSOLVE_BET_BUILDER_GROUPS aveva azzerato tutto).
            // Saltato se activeGroups.length > 0: il primo blocco ha già tentato il ricalcolo
            // e un eventuale fallimento ha già impostato il tipo a 'integral'; evita la doppia chiamata.
            if (context.state.bet.type === 'integral' && activeGroups.length === 0) {
                const prematchByEvent = {};
                for (const odd of context.state.bet.odds) {
                    if (odd.type === 'antepost') continue;
                    if (!prematchByEvent[odd.event_source]) prematchByEvent[odd.event_source] = [];
                    prematchByEvent[odd.event_source].push(odd);
                }
                const candidateGroups = Object.values(prematchByEvent).filter(g => g.length >= 2);

                if (candidateGroups.length > 0) {
                    context.commit('SET_LOADING_CART', true);
                    const recoveryResults = await Promise.all(
                        candidateGroups.map(group =>
                            context.dispatch('calculateBetBuilder', { odds: group }).then(r => ({ group, r }))
                        )
                    );
                    let allSuccess = true;
                    for (const { group, r: bbResult } of recoveryResults) {
                        if (bbResult.success) {
                            context.commit('SET_BET_BUILDER_GROUP', {
                                eventSource: group[0].event_source,
                                correlationId: bbResult.data.correlationId,
                                combinedPrice: bbResult.data.price,
                            });
                        } else {
                            allSuccess = false;
                        }
                    }
                    context.commit('SET_LOADING_CART', false);

                    if (allSuccess) {
                        // Conta le selezioni "virtuali": ogni gruppo betbuilder vale 1, ogni quota
                        // standalone vale 1. Determina single vs multiple di conseguenza.
                        const standaloneCount = Object.values(prematchByEvent).filter(g => g.length === 1).length
                            + context.state.bet.odds.filter(o => o.type === 'live').length;
                        const virtualSelections = candidateGroups.length + standaloneCount;
                        context.commit('SET_BET_TYPE', virtualSelections <= 1 ? 'single' : 'multiple');
                    }
                }
            }
        }

        return;
    },
    async acceptOdd(context, payload) {

        var odds = context.state.bet.odds

        for (let odd of odds) {

            if (odd.unique_id == payload.unique_id) {

                // Se la quota aveva un nuovo valore (CHANGED_ODD_VALUE), applicarlo prima di accettare
                if (odd.newOdd !== undefined) {
                    odd.outcome_odd_value = parseFloat(odd.newOdd);
                }

                delete odd.changed;
                delete odd.type_change;
                delete odd.newOdd;
                delete odd.oldOdd;
                break;
            }
        }

        await context.commit('SET_ODDS', odds)

    },
    async acceptAllOdds(context, payload) {

        var odds = context.state.bet.odds

        for (let odd of odds) {
            if (odd.changed) {
                // Applica il nuovo valore se presente (CHANGED_ODD_VALUE)
                if (odd.newOdd !== undefined) {
                    odd.outcome_odd_value = parseFloat(odd.newOdd);
                }
                delete odd.changed;
                delete odd.type_change;
                delete odd.newOdd;
                delete odd.oldOdd;
            }
        }

        await context.commit('SET_ODDS', odds)

    },
    async checkFixedBaseSystem(context, payload) {

        var fixed_bases = context.state.bet._system_detail.fixed_bases

        if (!fixed_bases.includes(payload.unique_id)) {

            if (fixed_bases.length < context.state.bet.odds.length - 2) {
                fixed_bases.push(payload.unique_id)
                await context.commit('SET_SYSTEM_FIXED_BASES', fixed_bases)
            } else {
                await context.commit('SET_SYSTEM_FIXED_BASES', [])
                await context.commit('SET_BET_TYPE', "multiple")
            }

        } else {
            var new_fixed_bases = remove(context.state.bet._system_detail.fixed_bases, function (odd) {
                return odd != payload.unique_id;
            });

            await context.commit('SET_SYSTEM_FIXED_BASES', new_fixed_bases)
        }

        await context.dispatch("refreshCart")
    },
    canUseFreeBets(context) {
        const isRetail = context.rootGetters['user/getType'] == 4 || context.rootGetters['user/getCashier'];
        const playingForOther = context.rootGetters['user/getUserIdOfUserToPlayBetFor'] != null;
        return !!context.rootGetters['user/getAuthenticated'] && !isRetail && !playingForOther;
    },
    async fetchAvailableFreeBets(context) {
        if (!await context.dispatch('canUseFreeBets')) return;

        const url = `${context.rootGetters['settings/getProxyUrl']}${proxyPath(context.rootGetters, '/cart/v3/available-free-bets')}`;
        try {
            const res = await axios.post(url, proxyBody(context.rootGetters, {}), {headers: proxyHeaders(context.rootGetters, getProxyAccessToken())});
            const data = res.data || {};
            context.commit('SET_AVAILABLE_FREE_BETS', data.hasFreebets ? (data.tokens || []) : []);
        } catch (error) {
            // In caso di errore non blocchiamo le chiamate compatible-free-bets.
            context.commit('SET_AVAILABLE_FREE_BETS', null);
            console.log(error);
        }
    },
    // Da chiamare a ogni variazione del carrello (tipo, quote, importo).
    scheduleCompatibleFreeBets(context) {
        const state = context.state;
        const selected = context.getters.getSelectedFreeBet;

        // Se l'importo non coincide più con la freebet scelta, la freebet si deseleziona.
        if (state.selected_free_bet_id && (!selected || !FREE_BET_TYPES.includes(state.bet.type)
            || Number(selected.amount) !== Number(state.bet._multiple_detail.amount))) {
            context.commit('SET_SELECTED_FREE_BET', { tokenId: null, previousAmount: null });
        }

        clearTimeout(freeBetsDebounceTimer);
        freeBetsDebounceTimer = setTimeout(() => context.dispatch('fetchCompatibleFreeBets'), FREE_BETS_DEBOUNCE_MS);
    },
    async fetchCompatibleFreeBets(context) {
        const state = context.state;

        const available = state.available_free_bets;
        const hasNoFreeBets = Array.isArray(available) && available.length === 0;
        if (!await context.dispatch('canUseFreeBets') || hasNoFreeBets
            || state.odds_sources.length === 0 || !FREE_BET_TYPES.includes(state.bet.type)) {
            context.commit('SET_COMPATIBLE_FREE_BETS', { tokens: [], key: null });
            return;
        }

        const key = freeBetsKey(state);
        if (key === state.free_bets_last_key) return;

        const { payload_request } = buildBetRequestPayload(context, {
            betContext: state.bet.context,
            lang: context.rootGetters['settings/getLanguage'],
            accept_odds: state.odds_variation,
            omitAmount: true,
        });

        const seq = state.free_bets_request_seq + 1;
        context.commit('SET_FREE_BETS_REQUEST', seq);

        const url = `${context.rootGetters['settings/getProxyUrl']}${proxyPath(context.rootGetters, '/cart/v3/compatible-free-bets')}`;
        try {
            const res = await axios.post(url, proxyBody(context.rootGetters, payload_request), {headers: proxyHeaders(context.rootGetters, getProxyAccessToken())});
            // Ignora risposte superate da una richiesta più recente.
            if (seq !== context.state.free_bets_request_seq) return;
            const data = res.data || {};
            context.commit('SET_COMPATIBLE_FREE_BETS', { tokens: data.tokens || [], key });
        } catch (error) {
            if (seq !== context.state.free_bets_request_seq) return;
            context.commit('SET_COMPATIBLE_FREE_BETS', { tokens: [], key: null });
            console.log(error);
        }
    },
    async selectFreeBet(context, tokenId) {
        const state = context.state;

        if (tokenId) {
            const token = state.compatible_free_bets.find(t => t.tokenId === tokenId);
            if (!token || !FREE_BET_TYPES.includes(state.bet.type)) return;

            // Conserva l'importo inserito dall'utente per ripristinarlo se la freebet viene tolta.
            const previousAmount = state.selected_free_bet_id ? state.free_bet_previous_amount : state.bet._multiple_detail.amount;
            context.commit('SET_SELECTED_FREE_BET', { tokenId, previousAmount });
            context.commit('SET_MULTIPLE_AMOUNT', Number(token.amount));
        } else {
            const selected = context.getters.getSelectedFreeBet;
            const previousAmount = state.free_bet_previous_amount;
            context.commit('SET_SELECTED_FREE_BET', { tokenId: null, previousAmount: null });
            if (selected && previousAmount != null && Number(state.bet._multiple_detail.amount) === Number(selected.amount)) {
                context.commit('SET_MULTIPLE_AMOUNT', Number(previousAmount));
            }
        }

        await context.dispatch('refreshCart');
    },
    async reloadFreeBets(context) {
        context.commit('CLEAR_FREE_BETS');
        await context.dispatch('fetchAvailableFreeBets');
        await context.dispatch('fetchCompatibleFreeBets');
    },
    async setConfirmedBet(context, payload) {
        context.commit('SET_CONFIRMED_BET', payload);
    },
    async clearConfirmedBet(context) {
        context.commit('CLEAR_CONFIRMED_BET');
    },
    async setLoadingCart(context, payload) {
        context.commit('SET_LOADING_CART', payload.status)
    },
    async resetCart(context) {
        context.commit('RESET_CART')
    },
    async initCart(context) {
        var now = new Date().getTime()
        if (now - context.state.created_at > 3 * 3600000) {
            context.commit('RESET_CART')
        } else {
            await context.dispatch("refreshCart")
        }
    },
    async initCartV2(context) { /* todo remove me */
        var now = new Date().getTime()
        if (now - context.state.created_at > 3 * 3600000) {
            context.commit('RESET_CART')
        } else {
            await context.dispatch("refreshCart")
        }
    },
    async refreshCart(context) {
        const percentageTaxValueOnWon = context.rootGetters['settings/getPercentageTaxValueOnWon'];
        const allowIntegralLiveBet = context.rootGetters['settings/getAllowIntegralLiveBet'];

        const bet = await cartHandler.refreshCart(context.state.settings, context.state.bet, context.state.bonus_rules, context.state.odds_sources, context.state.combinableMarkets, percentageTaxValueOnWon, allowIntegralLiveBet);
        context.commit('REFRESH_CART', bet)
    },
    async setCartSettings(context, payload) {
        context.commit('SET_CART_SETTINGS', payload)
    },
    async setBetType(context, payload) {
        // Integral dissolves the bet builder groups (below); a system cannot keep them.
        if (payload.type === 'system' && cartHasBetBuilder(context.state.bet)) {
            context.dispatch('settings/setSnackbar', true, {root: true})
            context.dispatch('settings/setSnackbarText', 'errors.betBuilderBetTypeReason', {root: true})
            return
        }
        const enableBetBuilder = context.rootGetters['settings/getEnableBetBuilder'];

        if (payload.type === 'integral') {
            context.commit('DISSOLVE_BET_BUILDER_GROUPS')
            context.commit('SET_BET_TYPE', payload.type)
        } else if ((payload.type === 'multiple' || payload.type === 'single') && enableBetBuilder) {
            // Groups of odds of the same event (bet builder may be formed again):
            // prematch, and live when the platform has the live bet builder
            const enableLiveBetBuilder = context.rootGetters['settings/getEnableLiveBetBuilder']
            const isLiveEventAvailable = context.rootGetters['betbuilder/isLiveEventAvailable']
            const candidateOdds = context.state.bet.odds.filter(o => o.type !== 'live' || (enableLiveBetBuilder && isLiveEventAvailable(o.event_source) !== false))
            const groups = {}
            for (const odd of candidateOdds) {
                if (!groups[odd.event_source]) groups[odd.event_source] = []
                groups[odd.event_source].push(odd)
            }
            const multiOddGroups = Object.values(groups).filter(g => g.length > 1)

            if (multiOddGroups.length > 0) {
                context.commit('SET_LOADING_CART', true)
                const typeResults = await Promise.all(
                    multiOddGroups.map(group =>
                        context.dispatch('calculateBetBuilder', { odds: group }).then(r => ({ group, r }))
                    )
                )
                let allSuccess = true
                for (const { group, r: bbResult } of typeResults) {
                    if (bbResult.success) {
                        context.commit('SET_BET_BUILDER_GROUP', {
                            eventSource: group[0].event_source,
                            correlationId: bbResult.data.correlationId,
                            combinedPrice: bbResult.data.price,
                        })
                    } else if (bbResult.errorCode === 'BET_BUILDER_UNAVAILABLE') {
                        // Provider overloaded or unreachable (temporary): keep the group, the player retries.
                        context.commit('SET_BET_BUILDER_UNAVAILABLE', { eventSource: group[0].event_source })
                    } else if (bbResult.errorCode === 'selections_redundant') {
                        context.commit('SET_BET_BUILDER_REDUNDANT', {
                            eventSource: group[0].event_source,
                            syntheticId: bbResult.quoteId || ('redundant__' + group[0].event_source),
                            redundantOutcomeId: bbResult.redundantOutcomeId,
                            impliedByOutcomeId: bbResult.impliedByOutcomeId,
                        })
                    } else {
                        allSuccess = false
                    }
                }
                context.commit('SET_LOADING_CART', false)
                // Cambia tipo se tutto ha avuto successo oppure era solo redundant (UI mostra l'avviso)
                if (allSuccess) {
                    context.commit('SET_BET_TYPE', payload.type)
                }
            } else {
                context.commit('SET_BET_TYPE', payload.type)
            }
        } else {
            context.commit('SET_BET_TYPE', payload.type)
        }
    },
    async setSystemComboDetail(context, payload) {
        context.commit('SET_SYSTEM_PARTS', payload.system_parts)
    },
    async setSystemAmountToDivide(context, payload) {
        context.commit('SET_SYSTEM_AMOUNT_TO_DIVIDE', payload.amount)
    },
    async setSystemAmountEqual(context, payload) {
        context.commit('SET_SYSTEM_AMOUNT_EQUAL', payload.amount)
    },
    async fetchBookedBet(context, payload) {
        return new Promise(async (resolve, reject) => {

            if (payload.code != '') {

                var payload_request = {
                    "code": payload.code
                }

                let url = `${context.rootGetters['settings/getBetApiUrl']}/cart/v2/get-booked-bet`;

                await axios.post(`${url}`, payload_request, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
                    .then(async (res) => {
                        if (!res.data.result) {
                            resolve({result: false})
                            return {result: false}
                        } else {
                            context.commit('RESET_CART')
                            context.commit('SET_BET_FROM_BOOKING', res.data)
                            context.dispatch('refreshCart')
                            resolve({result: true})
                            return {result: true}
                        }

                    }).catch((error) => {
                        return {result: false}
                        reject({result: false})
                        // console.log(error);
                    });

            } else {
                reject({result: false, error: 'no_code_provided'})
            }


        })

    },
    async setOddsVariation(context, payload) {
        context.commit('SET_ODDS_VARIATION', payload);
    },
    async setOddsInCart(context, payload) {
        var clone = {...payload}
        var odds_source = _.map(clone, 'unique_id')
        await context.commit('SET_ODDS_SOURCE', odds_source)
        context.commit('SET_ODDS', payload)
    },

    async setCreatedAtCart(context, payload) {
        context.commit('SET_CREATED_AT', payload)
    }
    ,
    async sendReviewBet(context, payload) { // deprecated delete me
        const url = `${context.rootGetters['settings/getUrlApi']}/cart/review-bet-by-user`;

        return await axios.post(`${url}`,
            {code: payload.code, mode: payload.mode},
            {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
            .then((res) => {
                return res
            }).catch((error) => {
                console.log(error);
            });
    },

    async addBetInAcceptance(context, payload) {
        context.commit('ADD_BET_IN_ACCEPTANCE', payload)
    },

    async removeBetFromAcceptance(context, payload) {
        context.commit('REMOVE_BET_IN_ACCEPTANCE', payload)
    },

    async removeBetFromAcceptanceByCode(context, betCode) {
        context.commit('REMOVE_BET_IN_ACCEPTANCE_BY_BET_CODE', betCode)
    },

    async addAcceptedBets(context, payload) {
        context.commit('ADD_ACCEPTED_BET', payload)
    },

    async removeBetFromAcceptedBets(context, payload) {
        context.commit('REMOVE_BET_FROM_ACCEPTED_BETS', payload)
    },

    async addRejectedBet(context, payload) {
        context.commit('ADD_REJECTED_BET', payload);
    },

    async removeBetFromRejectedBets(context, payload) {
        context.commit('REMOVE_BET_FROM_REJECTED_BETS', payload);
    },

    async addAcceptBetWithChanges(context, payload) {
        context.commit("ADD_ACCEPTED_BET_WITH_CHANGES", payload)
    },
    async removeBetFromAcceptedWithChange(context, payload) {
        context.commit('REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE', payload);
    },
    async removeBetFromAcceptedWithChangeByParent(context, parentBet) {
        context.commit('REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE_BY_PARENT', parentBet);
    },
    async setMobileCartOpen(context, payload) {
        context.commit('SET_MOBILE_CART_OPEN', payload);
    },
    async setCombinableMarkets(context, payload) {
        context.commit('SET_COMBINABLE_MARKETS', payload)
    },
    async addCombinableMarkets(context, payload) {
        context.commit('ADD_COMBINABLE_MARKETS', payload)
    },
    async setIsCartUpdating(context, payload){
        context.commit('SET_IS_CART_UPDATING', payload)
    },

    // Aggiorna in-place i valori di multiplicity di una quota nel carrello.
    // Chiamato quando il backend restituisce ODD_MULTIPLICITY_ERROR senza richiedere reload.
    async updateOddMultiplicity(context, payload) {
        context.commit('UPDATE_ODD_MULTIPLICITY', payload);
    },

    // Aggiorna outcome_odd_value nel carrello con i nuovi valori ricevuti dai warnings
    // di una place-bet andata a buon fine. Dopo il commit è necessario chiamare refreshCart
    // affinché tutti i totali (single/multiple/system/integral) vengano ricalcolati.
    async applyOddValueChanges(context, changedOdds) {
        context.commit('APPLY_ODD_VALUE_CHANGES', changedOdds);
    },

    // Segna una quota come disabilitata nel carrello.
    // Chiamato quando il backend restituisce ODD_DISABLED.
    async markOddDisabled(context, payload) {
        context.commit('MARK_ODD_DISABLED', payload);
    },

    // Segna una quota come sospesa (stato transitorio: la quota può tornare disponibile).
    // A differenza di ODD_DISABLED non blocca la scommessa: il pulsante resta cliccabile
    // così l'utente può ritentare in un secondo momento quando la quota riapre.
    async markOddSuspended(context, payload) {
        context.commit('MARK_ODD_SUSPENDED', payload);
    },

    // Rimuove il flag `suspended` da tutte le quote del carrello. Chiamato all'inizio
    // di ogni nuovo tentativo di placeBet così il backend ha l'opportunità di accettare
    // ora la quota; se è ancora sospesa, verrà ri-marcata dalla risposta d'errore.
    async clearOddsSuspended(context) {
        context.commit('CLEAR_ODDS_SUSPENDED');
    },

    // Chiamata dal socket ODDS_CHANGE_LIVE: per ogni quota nel payload con status=1
    // (giocabile), se la stessa quota è presente nel carrello con flag `suspended`,
    // lo rimuove così l'utente può ripiazzare senza ulteriori azioni.
    // Early-exit immediato se nessuna quota del carrello è sospesa: l'handler socket
    // è ad alta frequenza, deve restare leggero. Non aggiorna il valore della quota.
    // try/catch difensivo: il payload arriva dall'esterno e questo handler è in
    // mezzo alla catena SOCKET_ODDS_CHANGE_LIVE — un throw qui non deve mai
    // propagarsi e rompere il flusso (gli altri moduli a valle sono già stati
    // serviti dalla socket.module). Il catch interno isola anche singoli item
    // malformati senza scartare gli altri update validi nello stesso payload.
    socketClearSuspendedOnRecover(context, payload) {
        try {
            const odds = context.state.bet.odds;
            if (!odds || odds.length === 0) return;
            if (!odds.some(function(o) { return o.suspended === true; })) return;
            if (!Array.isArray(payload)) return;

            payload.forEach(function(eventPayload) {
                if (!eventPayload || !eventPayload.odds || !Array.isArray(eventPayload.odds.set)) return;
                eventPayload.odds.set.forEach(function(changeItem) {
                    try {
                        const attr = changeItem && changeItem._attributes;
                        if (!attr || parseInt(attr.status) !== 1) return;

                        const uniqueId = changeItem.unique_id;
                        const externalId = attr.external_id;

                        const target = odds.find(function(o) {
                            if (o.suspended !== true) return false;
                            return (uniqueId != null && o.unique_id == uniqueId) ||
                                   (externalId != null && o.outcome_id == externalId);
                        });

                        if (!target) return;

                        // FRZ.2 — never clear the suspended flag on an
                        // outcome that the server currently marks frozen.
                        // The socket carries only raw provider status (=1
                        // "running") which is uncorrelated with our freeze
                        // state; clearing here would show the player a
                        // clickable odd that rocky-bets then rejects with
                        // ODD_SUSPENDED, wasting a placement round-trip
                        // and confusing the UX. The registry is populated
                        // by both market stores (detailLive + previewLive)
                        // so both list and detail views feed the answer.
                        // Consult against the target's unique_id (never
                        // externalId — the registry is keyed by unique_id
                        // for cross-store consistency).
                        if (isOutcomeFrozen(target.unique_id)) return;

                        context.commit('CLEAR_ODD_SUSPENDED', { uniqueId: target.unique_id });
                    } catch (innerErr) {
                        console.warn('[cart/socketClearSuspendedOnRecover] skipped malformed item', innerErr);
                    }
                });
            });
        } catch (err) {
            console.error('[cart/socketClearSuspendedOnRecover] aborted', err);
        }
    },

    // Segna una quota come "valore cambiato" nel carrello.
    // Chiamato quando il backend restituisce CHANGED_ODD_VALUE.
    // L'utente vedrà old→new e potrà accettare il nuovo valore o rimuovere la quota.
    async markOddChanged(context, payload) {
        context.commit('MARK_ODD_CHANGED', payload);
    },

    //todo remove me i am deprecated
    // async acceptsRevisedBet(context, payload) {
    //     const settings = context.rootGetters['settings/getPlatformSettings'];
    //     const endpointUrlBase = settings.sircms_endpoint;
    //
    //     const url = `${endpointUrlBase}bookie/rocky-definition/definition/bet/review/self/accept`;
    //
    //     return await axios.post(
    //         url,
    //         { code: payload.code },
    //         {
    //             headers: { 'Authorization': `Bearer ${context.rootGetters['settings/getToken']}` },
    //             withCredentials: true  // Aggiunto per inviare i cookie di autenticazione
    //         }
    //     )
    //         .then((res) => {
    //             return res;
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // },

    async acceptsRevisedBet(context, payload) {
        const proxyUrl = context.rootGetters['settings/getProxyUrl'];
        const url = `${proxyUrl}${proxyPath(context.rootGetters, '/cart/v2/self/review/accept-bet')}`;
        const token = getProxyAccessToken();

        try {
            const res = await axios.post(
                url,
                proxyBody(context.rootGetters, { code: payload.code }),
                {
                    headers: proxyHeaders(context.rootGetters, token)
                }
            );
            return normalizeReviewResponse(res);
        } catch (error) {
            console.error('Errore durante accept-bet:', error);
            return normalizeReviewError(error);
        }
    },

    //todo remove this old rejectRevisedBet
    // async rejectRevisedBet(context, payload) {
    //     const settings = context.rootGetters['settings/getPlatformSettings'];
    //     const endpointUrlBase = settings.sircms_endpoint;
    //
    //     const url = `${endpointUrlBase}bookie/rocky-definition/definition/bet/review/self/reject`;
    //
    //     return await axios.post(
    //         url,
    //         { code: payload.code },
    //         {
    //             headers: { 'Authorization': `Bearer ${context.rootGetters['settings/getToken']}` },
    //             withCredentials: true  // Aggiunto per inviare i cookie di autenticazione
    //         }
    //     )
    //         .then((res) => {
    //             return res;
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // },

    async rejectRevisedBet(context, payload) {
        const proxyUrl = context.rootGetters['settings/getProxyUrl'];
        const url = `${proxyUrl}${proxyPath(context.rootGetters, '/rocky-definition/definition/bet/review/self/reject')}`;
        const token = getProxyAccessToken();

        try {
            const res = await axios.post(
                url,
                proxyBody(context.rootGetters, { code: payload.code }),
                {
                    headers: proxyHeaders(context.rootGetters, token)
                }
            );
            return normalizeReviewResponse(res);
        } catch (error) {
            console.error('Errore durante reject-bet:', error);
            return normalizeReviewError(error);
        }
    },
};

const mutations = {
    SET_AVAILABLE_FREE_BETS(state, tokens) {
        state.available_free_bets = tokens
    },
    SET_FREE_BETS_REQUEST(state, seq) {
        state.free_bets_request_seq = seq
        state.free_bets_loading = true
    },
    SET_COMPATIBLE_FREE_BETS(state, { tokens, key }) {
        state.compatible_free_bets = tokens
        state.free_bets_last_key = key
        state.free_bets_loading = false
        // Non più compatibile → deseleziona
        if (state.selected_free_bet_id && !tokens.some(t => t.tokenId === state.selected_free_bet_id)) {
            state.selected_free_bet_id = null
            state.free_bet_previous_amount = null
        }
    },
    SET_SELECTED_FREE_BET(state, { tokenId, previousAmount }) {
        state.selected_free_bet_id = tokenId
        state.free_bet_previous_amount = previousAmount
    },
    SET_MULTIPLE_AMOUNT(state, amount) {
        state.bet._multiple_detail.amount = amount
    },
    SET_PARENT_STAKE_LOCK(state, value) {
        state.parent_stake_lock = value === true
    },
    CLEAR_FREE_BETS(state) {
        state.available_free_bets = null
        state.compatible_free_bets = []
        state.selected_free_bet_id = null
        state.free_bet_previous_amount = null
        state.free_bets_last_key = null
        state.free_bets_loading = false
        state.free_bets_request_seq++
    },
    SET_CONFIRMED_BET(state, payload) {
        state.confirmed_bet = payload;
    },
    CLEAR_CONFIRMED_BET(state) {
        state.confirmed_bet = null;
    },
    SET_BET_BUILDER_GROUP(state, { eventSource, correlationId, combinedPrice }) {
        let isFirst = true;
        for (const odd of state.bet.odds) {
            if (odd.event_source === eventSource) {
                if (odd.bb_original_odd_value == null) {
                    Vue.set(odd, 'bb_original_odd_value', odd.outcome_odd_value);
                }
                Vue.set(odd, 'bet_builder_id', correlationId);
                Vue.set(odd, 'is_bet_builder', true);
                Vue.set(odd, 'bb_redundant', false);
                Vue.set(odd, 'bb_redundant_leg', false);
                Vue.set(odd, 'bb_implied_by', null);
                Vue.set(odd, 'bb_unavailable', false);
                odd.outcome_odd_value = isFirst ? combinedPrice : 1;
                isFirst = false;
            }
        }
    },
    SET_BET_BUILDER_REDUNDANT(state, { eventSource, syntheticId, redundantOutcomeId, impliedByOutcomeId }) {
        for (const odd of state.bet.odds) {
            if (odd.event_source === eventSource) {
                // The leg rocky-bets names as redundant (when it can tell) and the one covering it.
                const isRedundantLeg = redundantOutcomeId != null && String(odd.unique_id) === String(redundantOutcomeId);
                Vue.set(odd, 'bb_redundant_leg', isRedundantLeg);
                Vue.set(odd, 'bb_implied_by', isRedundantLeg && impliedByOutcomeId != null ? String(impliedByOutcomeId) : null);
                Vue.set(odd, 'bb_unavailable', false);
                if (odd.bb_original_odd_value != null) {
                    odd.outcome_odd_value = odd.bb_original_odd_value;
                    Vue.delete(odd, 'bb_original_odd_value');
                }
                Vue.set(odd, 'bet_builder_id', syntheticId);
                Vue.set(odd, 'is_bet_builder', true);
                Vue.set(odd, 'bb_redundant', true);
            }
        }
    },
    // Quote failed for a temporary provider problem: the selections stay a bet builder group,
    // without a price (placement blocked) until the player retries.
    SET_BET_BUILDER_UNAVAILABLE(state, { eventSource }) {
        for (const odd of state.bet.odds) {
            if (odd.event_source === eventSource) {
                if (odd.bb_original_odd_value != null) {
                    odd.outcome_odd_value = odd.bb_original_odd_value;
                    Vue.delete(odd, 'bb_original_odd_value');
                }
                Vue.set(odd, 'bet_builder_id', 'unavailable__' + eventSource);
                Vue.set(odd, 'is_bet_builder', true);
                Vue.set(odd, 'bb_redundant', false);
                Vue.set(odd, 'bb_redundant_leg', false);
                Vue.set(odd, 'bb_implied_by', null);
                Vue.set(odd, 'bb_unavailable', true);
            }
        }
    },
    DISSOLVE_BET_BUILDER_GROUPS(state) {
        for (const odd of state.bet.odds) {
            if (odd.bet_builder_id) {
                Vue.set(odd, 'bet_builder_id', null);
                Vue.set(odd, 'is_bet_builder', false);
                Vue.set(odd, 'bb_redundant', false);
                Vue.set(odd, 'bb_redundant_leg', false);
                Vue.set(odd, 'bb_implied_by', null);
                Vue.set(odd, 'bb_unavailable', false);
            }
            if (odd.bb_original_odd_value != null) {
                odd.outcome_odd_value = odd.bb_original_odd_value;
                Vue.delete(odd, 'bb_original_odd_value');
            }
        }
    },
    ADD_ODD_SOURCE(state, payload) {
        state.odds_sources.push(payload);
    },
    ADD_ODD(state, payload) {
        state.bet.odds.push(payload);
    },
    SET_ODDS_SOURCE(state, payload) {
        state.odds_sources = payload
    },
    SET_ODDS(state, payload) {
        state.bet.odds = payload
    },
    SET_LOADING_CART(state, payload) {
        state.loading = payload
    },
    REFRESH_CART(state, payload) {
        state.bet = payload
    },
    RESET_CART(state) {

        state.created_at = 0
        state.odds_sources = []

        state.bet.check = true
        state.bet.errors = []
        state.bet.errors_multi_info = []
        state.bet.warnings = []
        state.bet.integral_parts = []
        state.bet.odds = []
        state.bet.system_parts = []
        state.bet.type = 'single'
        state.bet.context = ''

        // single or multiple
        state.bet._multiple_detail.amount = state.settings.minAmount
        state.bet._multiple_detail.bonus = 0.00
        state.bet._multiple_detail.bonus_percentage = 0
        state.bet._multiple_detail.multiplicity = 0
        state.bet._multiple_detail.odds_total = 0
        state.bet._multiple_detail.profit = 0
        state.bet._multiple_detail.winning = 0
        state.bet._multiple_detail.winning_total = 0

        // integral
        state.bet._integral_detail.amount = state.settings.minAmount
        state.bet._integral_detail.amount_total = state.settings.minAmount
        state.bet._integral_detail.bonus_percentage = 0
        state.bet._integral_detail.bonus_max = 0.00
        state.bet._integral_detail.bonus_min = 0.00
        state.bet._integral_detail.combinations = 0
        state.bet._integral_detail.multiplicity = 0
        state.bet._integral_detail.odds_total_max = 0.00
        state.bet._integral_detail.odds_total_max = 0.00
        state.bet._integral_detail.profit_max = 0.00
        state.bet._integral_detail.profit_min = 0.00
        state.bet._integral_detail.winning_max = 0.00
        state.bet._integral_detail.winning_min = 0.00
        state.bet._integral_detail.winning_total_max = 0.00
        state.bet._integral_detail.winning_total_min = 0.00

        // system
        state.bet._system_detail.amount_system = 0.00
        state.bet._system_detail.amount_system_to_divide = null
        state.bet._system_detail.amount_system_equal = null
        state.bet._system_detail.bonus_max = 0.00
        state.bet._system_detail.bonus_min = 0.00
        state.bet._system_detail.combinations = 0
        state.bet._system_detail.fixed_bases = []
        // state.bet._system_detail.multiplicity = 0
        // state.bet._system_detail.odds_total_max = 0.00
        // state.bet._system_detail.odds_total_min = 0.00
        // state.bet._system_detail.profit_max = 0.00
        // state.bet._system_detail.profit_min = 0.00
        state.bet._system_detail.winning_max = 0.00
        state.bet._system_detail.winning_min = 0.00
        state.bet._system_detail.winning_total_max = 0.00
        state.bet._system_detail.winning_total_min = 0.00
        state.bet._system_detail.winning_all = 0.00

        state.confirmed_bet = null

        state.compatible_free_bets = []
        state.selected_free_bet_id = null
        state.free_bet_previous_amount = null
        state.free_bets_last_key = null
        state.free_bets_loading = false
        state.free_bets_request_seq++

    },
    SET_CART_SETTINGS(state, payload) {
        const cartSettings = findLodash(payload, {
            scope: 'cart',
            type: 'cart',
            source: 'betconsole'
        });

        state.settings = cartSettings?.detail ? { ...cartSettings.detail } : {};
        state.bonus_rules = [];

        filter(payload, function (rule) {
            if (rule.scope == "cart" && rule.type == "cart_bonus") {
                var source_split = rule.source.split('#');
                rule.detail.context = parseInt(source_split[1]);
                state.bonus_rules.push(rule.detail);
            }
        });
    },
    SET_BET_TYPE(state, payload) {
        state.bet.type = payload
    },
    SET_SYSTEM_PARTS(state, payload) {
        state.bet.system_parts = [...payload]
    },
    SET_SYSTEM_FIXED_BASES(state, payload) {
        state.bet._system_detail.fixed_bases = [...payload]
    },
    SET_SYSTEM_AMOUNT_TO_DIVIDE(state, payload) {
        state.bet._system_detail.amount_system_to_divide = payload
    },
    SET_SYSTEM_AMOUNT_EQUAL(state, payload) {
        state.bet._system_detail.amount_system_equal = payload
    },
    SET_BET_FROM_BOOKING(state, payload) {
        var betObj = JSON.parse(JSON.stringify(payload.result))
        state.bet.context = betObj.bet_context
        state.bet.type = betObj.type
        state.bet.odds = betObj.odds
        state.odds_sources = betObj.odds_sources

        switch (betObj.type) {
            case "single":
            case "multiple": {
                state.bet._multiple_detail = betObj._multiple_detail
            }
                break
            case "integral": {
                state.bet._integral_detail = betObj._integral_detail
                state.bet.integral_parts = betObj.integral_parts
            }
                break
            case "system": {
                state.bet._system_detail = betObj._system_detail
                state.bet.system_parts = betObj.system_parts
            }
                break
        }
    },
    SET_ODDS_VARIATION: (state, value) => {
        state.odds_variation = value;
    },

    SET_CREATED_AT: (state, value) => {
        state.created_at = value;
    },

    setAcceptingBets: (state, value) => {
        state.accepting_bets = value;
    },

    ADD_BET_IN_ACCEPTANCE: (state, value) => {
        // Il socket può aver già risolto la bet prima della risposta di place-bet:
        // non aggiungerla, altrimenti resterebbe "in revisione" per sempre
        if (!value || state.resolved_review_codes.includes(String(value.code))) return;
        state.accepting_bets = [
            ...state.accepting_bets.filter(bet => String(bet.code) !== String(value.code)),
            value,
        ];
    },

    REMOVE_BET_IN_ACCEPTANCE: (state, payload) => {
        const betCodeToRemove = payload.code;
        markReviewResolved(state, [betCodeToRemove]);
        state.accepting_bets = state.accepting_bets.filter(bet => {
            return bet.code != betCodeToRemove
        })
    },

    REMOVE_BET_IN_ACCEPTANCE_BY_BET_CODE: (state, betCode) => {
        markReviewResolved(state, [betCode]);

        const betCodeToRemove = betCode;
        state.accepting_bets = state.accepting_bets.filter(bet => {
            return bet.code != betCodeToRemove
        })
    },

    ADD_ACCEPTED_BET: (state, payload) => {
        state.accepted_bets.push(payload)
    },

    ADD_ACCEPTED_BET_WITH_CHANGES: (state, payload) => {
        if (!payload || state.resolved_review_codes.includes(String(payload.code))) return;
        // Dedup: un nuovo evento per lo stesso codice sostituisce quello esistente
        state.accepted_with_change = [
            ...state.accepted_with_change.filter(bet => String(bet.code) !== String(payload.code)),
            payload,
        ];
    },

    REMOVE_BET_FROM_ACCEPTED_BETS: (state, betCode) => {
        state.accepted_bets = state.accepted_bets.filter(bet => {
            return bet.code != betCode
        })
    },

    ADD_REJECTED_BET: (state, payload) => {
        state.rejected_bets.push(payload);
    },

    REMOVE_BET_FROM_REJECTED_BETS: (state, betCode) => {
        state.rejected_bets = state.rejected_bets.filter(bet => {
            return bet.code != betCode
        })
    },

    REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE: (state, betCode) => {
        markReviewResolved(state, [betCode]);
        state.accepted_with_change = state.accepted_with_change.filter(bet => String(bet.code) !== String(betCode));
    },

    REMOVE_BET_FROM_ACCEPTED_WITH_CHANGE_BY_PARENT: (state, parentBet) => {
        const removed = state.accepted_with_change.filter(bet => bet.parentBet === parentBet);
        markReviewResolved(state, removed.map(bet => bet.code));
        state.accepted_with_change = state.accepted_with_change.filter(bet => bet.parentBet !== parentBet);
    },

    SET_MOBILE_CART_OPEN: (state, status) => {
        state.mobileCartOpen = status;
    },
    SET_COMBINABLE_MARKETS(state, payload) {
        state.combinableMarkets = payload
    },
    ADD_COMBINABLE_MARKETS(state, payload) {

        const objIndex = state.combinableMarkets.findIndex(el => {
            return el.tournamentId === payload.tournamentId
        })

        if (objIndex != -1) {
            state.combinableMarkets[objIndex] = payload

        } else {
            state.combinableMarkets.push(payload)
        }
    },
    SET_IS_CART_UPDATING(state, payload) {
        state.isCartUpdating = payload != null ? payload : false
    },

    // Aggiorna multiplicityMin / multiplicityMax / multiplicity stringa su una quota nel carrello.
    // Imposta anche multiplicity_changed: true come segnale visivo al componente CartMarketView.
    // BUGFIX: aggiorna anche i campi snake_case (multiplicity_min / multiplicity_max) letti da
    // multiplicityVincols in cartVincols.js. Senza questo aggiornamento, refreshCart non
    // genera l'errore in bet.errors e l'errore sparisce alla chiusura della modale.
    UPDATE_ODD_MULTIPLICITY(state, payload) {
        var odd = state.bet.odds.find(function(o) {
            return o.unique_id == payload.outcomeId || o.outcome_id == payload.outcomeId;
        });
        if (odd) {
            odd.multiplicityMin = payload.multiplicityMin;
            odd.multiplicityMax = payload.multiplicityMax;
            odd.multiplicity = payload.multiplicityMin + '-' + payload.multiplicityMax;
            odd.multiplicity_min = String(payload.multiplicityMin);
            odd.multiplicity_max = String(payload.multiplicityMax);
            odd.multiplicity_changed = true;
        }
    },

    // Segna una quota come disabilitata. Il componente CartMarketView può leggere odd.disabled
    // per mostrare la quota in stato disabilitato senza rimuoverla di forza.
    MARK_ODD_DISABLED(state, payload) {
        var odd = state.bet.odds.find(function(o) {
            return o.unique_id == payload.outcomeId || o.outcome_id == payload.outcomeId;
        });
        if (odd) {
            // Vue.set: `disabled` is not on the initial object, a plain assignment is not
            // reactive (neither the cart nor the parent bridge would see it)
            Vue.set(odd, 'disabled', true);
        }
    },

    // Segna una quota come sospesa (stato transitorio). Vue.set obbligatorio: `suspended`
    // è una proprietà non presente nell'oggetto iniziale e il template deve reagire al cambio.
    MARK_ODD_SUSPENDED(state, payload) {
        var odd = state.bet.odds.find(function(o) {
            return o.unique_id == payload.outcomeId || o.outcome_id == payload.outcomeId;
        });
        if (odd) {
            Vue.set(odd, 'suspended', true);
        }
    },

    // Rimuove il flag `suspended` da tutte le quote del carrello (reset al retry).
    CLEAR_ODDS_SUSPENDED(state) {
        state.bet.odds.forEach(function(odd) {
            if (odd.suspended) {
                Vue.set(odd, 'suspended', false);
            }
        });
    },

    // Rimuove il flag `suspended` da una singola quota (riapertura ricevuta via socket).
    CLEAR_ODD_SUSPENDED(state, payload) {
        var odd = state.bet.odds.find(function(o) {
            return o.unique_id == payload.uniqueId;
        });
        if (odd && odd.suspended) {
            Vue.set(odd, 'suspended', false);
        }
    },

    // Segna una quota come "valore cambiato" senza rimuoverla dal carrello.
    // Vue.set è obbligatorio perché changed/newOdd/oldOdd sono proprietà NUOVE non definite
    // nell'oggetto iniziale: senza Vue.set, Vue 2 non le traccia in modo reattivo.
    MARK_ODD_CHANGED(state, payload) {
        var odd = state.bet.odds.find(function(o) {
            return o.unique_id == payload.outcomeId || o.outcome_id == payload.outcomeId;
        });
        if (odd) {
            Vue.set(odd, 'changed', true);
            Vue.set(odd, 'type_change', 'changed_odd_value');
            Vue.set(odd, 'newOdd', String(payload.newOdd));
            Vue.set(odd, 'oldOdd', payload.odd);
        }
    },

    // Aggiorna outcome_odd_value delle quote per cui il backend ha accettato la scommessa
    // con valore variato (warnings CHANGED_ODD_VALUE nella risposta place-bet con result:true).
    // Salva old_odd per la visualizzazione nel riepilogo scommessa confermata.
    // Vue.set obbligatorio: old_odd è una proprietà nuova non presente nell'oggetto iniziale.
    APPLY_ODD_VALUE_CHANGES(state, changedOdds) {
        changedOdds.forEach(function(item) {
            var odd = state.bet.odds.find(function(o) {
                return o.unique_id == item.outcomeId || o.outcome_id == item.outcomeId;
            });
            if (odd) {
                Vue.set(odd, 'old_odd', parseFloat(item.oldOdd));
                odd.outcome_odd_value = parseFloat(item.newOdd);
            }
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
